module.exports = __webpack_public_path__ + "img/bg-poly.01829eaa.png";